import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useSubtitle from 'src/hooks/useSubtitle';
import useUpdateStore from 'src/hooks/useUpdateStore';
import useWatchTime from 'src/hooks/useWatchTime';
import ApplicationService from 'src/services/ApplicationService';
import { SELECTOR_CURRENT_CUE_TEXT } from 'src/store/reducers/subtitles';

const useTextTrack = () => {
  const { activeTrack } = useSubtitle();
  const { updateCurrentCueTextInStore } = useUpdateStore();
  const { currentTime } = useWatchTime();
  const currentCueText = useSelector(SELECTOR_CURRENT_CUE_TEXT);

  useEffect(() => {
    if (!activeTrack) return;

    const cueText = ApplicationService.subtitle.currentCueText || '';
    updateCurrentCueTextInStore(cueText);
  }, [currentTime, activeTrack, updateCurrentCueTextInStore]);

  return {
    currentCueText,
  };
};

export default useTextTrack;
